module.exports = __webpack_public_path__ + "media/images/basic_logos/download-blue-b41026780a3051c3b6dfdf5e4f297974.svg";